export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wsWorker.worker.1d3ef0c6.worker.js");
}
